import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { BaseConfirmDialog } from './BaseConfirmDialog';
export const GetScheduleDialogTID = (parentTestId)=>getTestIds(parentTestId);
export const ScheduleDialog = (props)=>{
    const { ScheduleDialogTID } = useMemo(()=>GetScheduleDialogTID(), []);
    const { t: scheduleTexts } = useLocaleKeys('vendorOnboarding.adHocBillModal.confirmationDialogs.schedule');
    const [loading, setLoading] = useState(false);
    const handleConfirm = async ()=>{
        if (loading) return;
        setLoading(true);
        const succeeded = await props.onConfirm();
        if (!succeeded) setLoading(false);
    };
    return /*#__PURE__*/ _jsx(BaseConfirmDialog, {
        testIds: ScheduleDialogTID,
        title: scheduleTexts.title(),
        bodyIntro: scheduleTexts.bodyIntro(),
        bodyDescription: scheduleTexts.bodyDescription(),
        companyName: props.companyName,
        contactName: props.contactName,
        email: props.email,
        coverCreditCardFees: props.coverCreditCardFees,
        backLabel: scheduleTexts.backButton(),
        primaryLabel: scheduleTexts.scheduleButton(),
        loading: loading,
        onBack: props.onBack,
        onConfirm: handleConfirm
    });
};
